import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var sliderStyle = function sliderStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6,
    primary4 = _getThemeData.primary4,
    primary1 = _getThemeData.primary1;
  return css([".ant-slider.ant-slider{.ant-slider-track{background-color:", ";}.ant-slider-handle{border-color:", ";}.ant-slider-dot-active{border-color:", ";}.ant-slider-handle:focus{border-color:", ";box-shadow:0 0 0 2px ", ";}&:hover{.ant-slider-track{background-color:", ";}.ant-slider-handle{border-color:", ";}.ant-slider-dot-active{border-color:", ";}}}"], primary4, primary4, primary4, primary6, primary1, primary6, primary6, primary6);
};
export default sliderStyle;